__turbopack_context__.v({
  "desktopFooter": "Footer-module__JpGO5q__desktopFooter",
  "mobileFooter": "Footer-module__JpGO5q__mobileFooter",
});
